<template>
  <div>
    <DxPopup
      :visible="popupVisible"
      :drag-enabled="true"
      :hide-on-outside-click="false"
      :show-title="true"
      :width="'65%'"
      :height="310"
      title="Add Item"
      :ref="'add-item-popup'"
      @hidden="popupHidden"
      @shown="popupShown"
      :showCloseButton="false"
      :wrapperAttr="{ class: 'css-v2 gc-popup' }"
    >
      <DxToolbarItem
        :options="this.searchOptions"
        widget="dxButton"
        location="after"
      ></DxToolbarItem>

      <GcPopUpSearchForItem
        v-if="searchForItem && searchForItem.visible"
        :setVisible="searchForItem.visible"
        :callBack="searchForItem.popUpCallBack"
        :productListQuery="
          searchForItem.productListQuery
            ? searchForItem.productListQuery
            : undefined
        "
        :productListColumns="
          searchForItem.columns ? searchForItem.columns : undefined
        "
        :searchForItem="searchForItem.searchForItemData"
        :baseView="baseView"
      ></GcPopUpSearchForItem>

      <div class="css-v2 gc-popup-form">
        <gc-form
          :formOptions="{
            gcLabelLocation: 'left',
          }"
          :formItems="getFormItems"
          :formHeight="185"
          :isNormal="true"
          :data-model="formDataModel"
          :formMode="'create'"
          :validationGroup="'gcPopupConfig-gc-popup-form-data'"
          :formTitle="'gc-popup'"
          :ref="'add-item-popup-form'"
        ></gc-form>
      </div>

      <div class="footer edit-product-item-popup-footer">
        <DxButton
          text="Add"
          type="default"
          styling-mode="contained"
          class="save-btn"
          @click="saveAddItem()"
          :disabled="this.saveDisabled"
          :ref="'footer-save-btn'"
        />
        <DxButton
          text="Cancel"
          type="default"
          styling-mode="contained"
          class="cancel-btn"
          @click="popupHidden"
        />
      </div>
    </DxPopup>
  </div>
</template>

<script>
import ApiService from "../_services/api/api.service";
import BaseViewMixin from "../v1/_mixins/base.view";
import { SalesOrderService } from "../_services/api/sales/sales-order.service";
import { PurchaseOrder } from "../_services/api/purchasing/purchase-order.service";

export default {
  props: {
    setVisible: Boolean,
    callBack: {
      type: Function,
      default: function () {},
    },
    addSalesOrderItemData: Object,
    setLoading: {
      type: Function,
      default: function () {},
    },
  },
  mixins: [BaseViewMixin],
  data() {
    return {
      CellValueChanged: false,
      toolBarHeight: 0,
      formDataModel: {
        Code: undefined,
        Description: undefined,
        SalesUM: undefined,
        SalesUMQty: 0.0,
        SalesTaxPcnt: 0.0,
        Price: 0.0,
        Discount: undefined,
        Amount: 0.0,
        Comment: undefined,
      },
      saveDisabled: true,
      searchForItem: undefined,
      searchOptions: {
        text: "Search Item",
        type: "default",
        stylingMode: "contained",
        onClick: this.searchForProductItem,
      },
      salesOrderData: {
        SalesOrderCode: "",
        SalesOrderTypeCode: "",
        BranchCode: "",
        CustomerCode: "",
        ExchangeRate: "",
        TransactionDate: "",
      },
      isValidItem: false,
      orderType: "so",
      selectedProduct: undefined,
    };
  },
  async created() {
    if (this.addSalesOrderItemData.orderType != undefined) {
      this.orderType = this.addSalesOrderItemData.orderType.toLowerCase();
    }

    var dateIn = new Date(this.addSalesOrderItemData.DateIn);
    this.salesOrderData.SalesOrderCode =
      this.addSalesOrderItemData.SalesOrderCode;
    this.salesOrderData.BranchCode = this.addSalesOrderItemData.BranchCode;
    this.salesOrderData.CustomerCode = this.addSalesOrderItemData.CustomerCode;
    this.salesOrderData.TransactionDate = dateIn.toFilterDateString();
    this.salesOrderData.SalesOrderTypeCode =
      this.addSalesOrderItemData.SalesOrderTypeCode;
    if (this.orderType == "so") {
      // Getting the exchange rate from the sales order
      var exchangeRate = await this.getExchangeRate(
        this.salesOrderData.SalesOrderCode
      );
      if (exchangeRate == undefined) {
        this.salesOrderData.ExchangeRate = 1.0;
      } else {
        this.salesOrderData.ExchangeRate = exchangeRate[0].ExchangeRate;
      }
    }
  },
  computed: {
    popupVisible() {
      return this.setVisible ? true : false;
    },
    getSalesUMExpr() {
      if (this.orderType == "gi") {
        return "SupplierUM";
      } else {
        return "UnitOfMeasureCode";
      }
    },
    getSalesUMDataSourceConfig() {
      if (this.orderType == "gi") {
        return {
          endpoint: "api/ProductPurchaseList",
          filter: [
            ["ProductCode", "=", this.formDataModel.Code],
            ["SupplierCode", "=", this.addSalesOrderItemData.SupplierCode],
          ],
        };
      }

      return {
        endpoint: "api/ProductUnitOfMeasure",
        filter: [
          ["ProductCode", "=", this.formDataModel.Code],
          ["BranchCode", "=", this.addSalesOrderItemData.BranchCode],
        ],
      };
    },
    getFormItems() {
      return [
        {
          itemType: "group",
          caption: "",
          colCount: 2,
          items: [
            {
              itemType: "group",
              caption: "",
              items: [
                {
                  // screenField: "Code",
                  dataField: "Code",
                  editorType:
                    this.orderType == "gi" ? "dxSelectBox" : "dxTextBox",
                  editorOptions: {
                    onFocusIn: (e) => {
                      e.event.target.select();
                    },
                    allowUpdate: true,
                    onValueChanged: async () => {
                      await this.getItemData(
                        this.formDataModel,
                        this.salesOrderData
                      );
                      if (this.isValidItem) {
                        setTimeout(() => {
                          if (this.orderType == "so") {
                            this.$refs["add-item-popup-form"].$refs[
                              "gc-form-comp"
                            ].instance
                              .getEditor("SalesUM")
                              .focus();
                          } else if (this.orderType == "gi") {
                            this.$refs["add-item-popup-form"].$refs[
                              "gc-form-comp"
                            ].instance
                              .getEditor("SalesUMQty")
                              .focus();
                          }
                        }, 10);
                      }
                    },
                    dataSource: PurchaseOrder.dataSourceConfig(
                      "api/ProductPurchaseList",
                      {
                        filter: [
                          [
                            "SupplierCode",
                            "=",
                            `${this.addSalesOrderItemData.SupplierCode}`,
                          ],
                        ],
                      }
                    ),
                    displayExpr: "ProductCode",
                    valueExpr: "ProductCode",
                    searchTimeout: 10,
                    searchEnabled: true,
                    searchExpr: [
                      "ProductCode",
                      "PurchaseDescription1",
                      "ProductDescription1",
                    ],
                    onSelectionChanged: (e) => {
                      this.onProductCodeSelected(e);
                    },
                    itemTemplate: (data) => {
                      return ` <div class="custom-auto-complete" id="${data.ProductCode}" >
                            <span class="auto-complete-primary">
                              ${data.ProductCode}
                            </span>
                            <span class="record-secondary gc-grid-code">
                              ${data.PurchaseDescription1}
                            </span> 
                          </div>`;
                    },
                    dropDownOptions: {
                      minWidth: 400,
                    },
                  },
                },
                {
                  screenField: "SalesUM",
                  dataField: "SalesUM",
                  cellTemplate: "Record",
                  gridDataField: "SalesUM",
                  cellTemplateRecord: {
                    primary: [
                      {
                        dataField: "SalesUM",
                      },
                    ],
                  },
                  editorOptions: {
                    onValueChanged: (e) => {
                      if (e.event) {
                        this.salesUMValueChanged();
                      }
                    },
                    allowUpdate: this.orderType != "gi",
                    onKeyDown: (e) => {
                      this.goToNextField(e, "SalesUMQty");
                    },
                  },
                  dataSourceConfig:
                    this.orderType != "gi"
                      ? this.getSalesUMDataSourceConfig
                      : undefined,
                  valueExpr: this.getSalesUMExpr,
                  displayExpr: this.getSalesUMExpr,
                  formField: {
                    label: "UM",
                    dataField: "SalesUM",
                  },
                },
                {
                  screenField: "SalesUMQty",
                  dataField: "SalesUMQty",
                  editorOptions: {
                    onFocusIn: (e) => {
                      e.event.target.select();
                    },
                    allowUpdate: true,
                    search: true,
                    onValueChanged: (e) => {
                      if (e.event) {
                        this.salesValueChanged();
                      }
                    },
                    onKeyDown: (e) => {
                      this.goToNextField(e, "Price");
                    },
                  },
                },
                {
                  screenField: "Price",
                  dataField: "Price",
                  format: "Decimal-16-2",
                  allowUpdate: true,
                  editorOptions: {
                    format: "Decimal-16-2",
                    onValueChanged: (e) => {
                      if (e.event) {
                        this.salesValueChanged();
                      }
                    },
                    onFocusIn: (e) => {
                      e.event.target.select();
                    },
                    onKeyDown: (e) => {
                      if (this.orderType != "gi")
                        this.goToNextField(e, "Discount");
                      else this.goToNextField(e, "SalesTaxPcnt");
                    },
                  },
                },
                {
                  screenField: "DiscountPercent",
                  dataField: "Discount",
                  allowUpdate: true,
                  visible: this.orderType != "gi",
                  editorOptions: {
                    allowUpdate: true,
                    search: true,
                    onValueChanged: (e) => {
                      if (e.event) {
                        this.salesValueChanged();
                      }
                    },
                    onKeyDown: (e) => {
                      if (this.orderType == "gi")
                        this.goToNextField(e, "SalesTaxPcnt");
                      else this.goToNextField(e, "Comment");
                    },
                    onFocusIn: (e) => {
                      e.event.target.select();
                    },
                  },
                },
                {
                  screenField: "TaxPercent",
                  dataField: "SalesTaxPcnt",
                  allowUpdate: true,
                  visible: this.orderType == "gi",
                  editorOptions: {
                    allowUpdate: true,
                    search: true,
                    onValueChanged: (e) => {
                      if (e.event) {
                        this.salesValueChanged();
                      }
                    },
                    onKeyDown: (e) => {
                      this.goToNextField(e, "Comment");
                    },
                    onFocusIn: (e) => {
                      e.event.target.select();
                    },
                  },
                },
                {
                  screenField: "Amount",
                  dataField: "Amount",
                  format: "Decimal-16-2",
                  editorOptions: {
                    format: "Decimal-16-2",
                    allowUpdate: false,
                  },
                  label: {
                    text: "Total",
                  },
                },
              ],
            },
            {
              itemType: "group",
              caption: "",
              items: [
                {
                  screenField: "Description",
                  dataField: "Description",
                  label: {
                    text: " ",
                  },
                  editorOptions: {
                    allowUpdate: false,
                  },
                },
                {
                  screenField: "Comment",
                  dataField: "Comment",
                  editorOptions: {
                    onFocusIn: (e) => {
                      e.event.target.select();
                    },
                    onKeyDown: (e) => {
                      if (
                        e.event.key == "Enter" ||
                        (e.event.key == "Tab" && e.event.shiftKey == false)
                      ) {
                        setTimeout(() => {
                          var btn = this.$refs["footer-save-btn"];
                          btn.instance.focus();
                        }, 1);
                      }
                    },
                  },
                },
              ],
            },
          ],
        },
      ];
    },
  },
  watch: {},
  methods: {
    goToNextField(e, dataField) {
      if (
        e.event.key == "Enter" ||
        (e.event.key == "Tab" && e.event.shiftKey == false)
      ) {
        setTimeout(() => {
          this.$refs["add-item-popup-form"].$refs["gc-form-comp"].instance
            .getEditor(dataField)
            .focus();
        }, 1);
      }
    },
    onProductCodeSelected(e) {
      this.selectedProduct = e.selectedItem;
    },
    searchForProductItem() {
      let query = undefined;
      let columns = undefined;
      if (this.orderType == "gi") {
        query = {
          endpoint: "ProductPurchaseList",
          select: ["ProductCode", "PurchaseDescription1"],
          filter: [
            ["SupplierCode", "=", `${this.addSalesOrderItemData.SupplierCode}`],
          ],
          serverPaging: true,
          allowGrouping: false,
        };

        columns = [
          {
            screenField: "Code",
            label: "Product",
            dataField: "ProductCode",
          },
          {
            screenField: "ItemDescription",
            label: "Description",
            dataField: "PurchaseDescription1",
          },
        ];
      }
      this.searchForItem = {
        visible: true,
        popUpCallBack: this.searchForItemCallBack,
        productListQuery: query,
        columns: columns,
      };
    },
    searchForItemCallBack(item, updated) {
      if (updated) {
        if (this.orderType == "gi") {
          item.Code = item.ProductCode;
        }
        this.formDataModel.Code = item.Code;
      }
      this.searchForItem = undefined;
    },
    setSaveDisabled(state) {
      this.saveDisabled = state;
    },
    popupHidden() {
      this.callBack(false);
    },
    popupShown() {
      this.$refs["add-item-popup-form"].$refs["gc-form-comp"].instance
        .getEditor("Code")
        .focus();
    },
    async getExchangeRate(salesOrderCode) {
      const requestSalesOrderData = {
        url: "api/SalesOrder",
        top: "1",
        select: "ExchangeRate",
        filter: "Code eq " + salesOrderCode,
      };
      var exchangeRate = undefined;
      await ApiService.oDataGet(requestSalesOrderData)
        .then((res) => {
          if (res.data.value.length > 0) {
            exchangeRate = res.data.value;
          }
        })
        .catch(() => {});
      return exchangeRate;
    },
    async getSaleItemData(productDetails, salesOrderData) {
      const salesItemParams = {
        TransactionDate: salesOrderData.TransactionDate,
        SalesOrderTypeCode: salesOrderData.SalesOrderTypeCode,
        BranchCode: salesOrderData.BranchCode,
        CustomerCode: salesOrderData.CustomerCode,
        ExchangeRate: salesOrderData.ExchangeRate,
        ItemType: "S",
        ItemCode: productDetails.Code,
        SalesUM: productDetails.UnitOfMeasureCode,
        SalesUMQty: this.formDataModel.SalesUMQty,
      };

      var saleItemPriceData = undefined;

      await SalesOrderService.getSaleItemPrice(salesItemParams)
        .then((res) => {
          saleItemPriceData = res.data;
        })
        .catch((err) => {
          this.$logger.debug(err);
        });

      return saleItemPriceData;
    },
    itemDoesNotExist(itemCode) {
      this.$alert(`Product ${itemCode} does not exist.`, "Invalid Item Code");
      this.formDataModel.Description = " ";
      this.formDataModel.Price = 0.0;
      this.saveDisabled = true;
      this.isValidItem = false;
      this.setLoading(false);
    },
    async getProductDetails(itemCode, branchCode) {
      const productDataUrl = {
        url: "api/LineItemData",
        top: "1",
        filter: `Code eq '${itemCode}' and BranchCode eq '${branchCode}' and IsDefault eq 'Y'`,
      };

      var productDetails = undefined;
      await ApiService.oDataGet(productDataUrl)
        .then((res) => {
          if (res.data.value.length > 0) {
            productDetails = res.data.value;
          }
        })
        .catch(() => {});

      return productDetails;
    },
    async getItemDataForSO(item, salesOrderData) {
      this.setLoading(true);
      var productDetails = await this.getProductDetails(
        item.Code,
        salesOrderData.BranchCode
      );
      if (productDetails == undefined) {
        this.itemDoesNotExist(item.Code);
        return;
      }

      this.isValidItem = true;

      var saleItemPriceData = await this.getSaleItemData(
        productDetails[0],
        salesOrderData
      );
      this.updateFormModel(productDetails[0], saleItemPriceData);
      if (this.formDataModel.SalesUMQty > 0) {
        this.saveDisabled = false;
      } else {
        this.saveDisabled = true;
      }

      this.setLoading(false);
    },
    async getProductPurchaseData(itemCode, supplierCode) {
      const productPurchaseDataUrl = {
        url: "api/ProductPurchaseList",
        top: "1",
        filter: `SupplierCode eq '${supplierCode}' and ProductCode eq '${itemCode}'`,
      };

      var productDetails = undefined;

      await ApiService.oDataGet(productPurchaseDataUrl)
        .then((res) => {
          if (res.data.value.length > 0) {
            productDetails = res.data.value[0];
          }
        })
        .catch(() => {});

      return productDetails;
    },
    async getItemDataForGI(item, supplierCode) {
      this.setLoading(true);
      let productDetails = this.selectedProduct
        ? this.selectedProduct
        : await this.getProductPurchaseData(item.Code, supplierCode);
      if (productDetails == undefined) {
        this.itemDoesNotExist(item.Code);
        return;
      }

      this.isValidItem = true;
      (this.formDataModel.Description = productDetails.PurchaseDescription1),
        (this.formDataModel.SalesUM = productDetails.SupplierUM),
        (this.formDataModel.Price = productDetails.SupplierPrice),
        (this.formDataModel.SalesTaxPcnt = productDetails.TaxPcnt),
        (this.formDataModel.ItemType = productDetails.ItemType);
      this.formDataModel.TaxCode = productDetails.TaxCode;
      (this.formDataModel.Discount = 0.0),
        (this.formDataModel.Amount =
          this.formDataModel.SalesUMQty *
          this.formDataModel.Price *
          ((100.0 - this.formDataModel.Discount) / 100.0));
      this.formDataModel.Amount =
        this.formDataModel.Amount +
        this.formDataModel.Amount * (this.formDataModel.SalesTaxPcnt / 100.0);
      this.formDataModel.Amount = this.formDataModel.Amount.roundNumber(2);

      if (this.formDataModel.SalesUMQty > 0) {
        this.saveDisabled = false;
      } else {
        this.saveDisabled = true;
      }

      this.selectedProduct = undefined;
      this.setLoading(false);
    },
    async getItemData(item, salesOrderData) {
      if (this.orderType == "so") {
        await this.getItemDataForSO(item, salesOrderData);
      } else if (this.orderType == "gi") {
        await this.getItemDataForGI(
          item,
          this.addSalesOrderItemData.SupplierCode
        );
      }
    },
    async salesUMValueChanged() {
      if (this.orderType == "so") {
        if (this.isValidItem) {
          var productDetails = {
            Code: this.formDataModel.Code,
            Description1: this.formDataModel.Description,
            UnitOfMeasureCode: this.formDataModel.SalesUM,
          };

          var saleItemPriceData = await this.getSaleItemData(
            productDetails,
            this.salesOrderData
          );
          this.updateFormModel(productDetails, saleItemPriceData);
          if (this.formDataModel.SalesUMQty > 0) {
            this.saveDisabled = false;
          } else {
            this.saveDisabled = true;
          }
        }
      }
    },
    salesValueChanged() {
      if (this.isValidItem) {
        this.formDataModel.Amount =
          this.formDataModel.SalesUMQty *
          this.formDataModel.Price *
          ((100.0 - this.formDataModel.Discount) / 100.0);
        this.formDataModel.Amount =
          this.formDataModel.Amount +
          this.formDataModel.Amount * (this.formDataModel.SalesTaxPcnt / 100.0);
        if (this.formDataModel.SalesUMQty > 0) {
          this.saveDisabled = false;
        } else {
          this.saveDisabled = true;
        }
      }
    },
    updateFormModel(item, saleItemPriceData) {
      this.formDataModel.Description = item.Description;
      this.formDataModel.SalesUM = saleItemPriceData.SalesUM;
      this.formDataModel.SalesUMQty = saleItemPriceData.SalesUMQty;
      this.formDataModel.Price = 0.0;
      this.formDataModel.Price = saleItemPriceData.SalesUMFXPrice;
      this.formDataModel.Discount = saleItemPriceData.DiscPcnt;
      this.formDataModel.SalesTaxPcnt = saleItemPriceData.SalesTaxPcnt;
      this.formDataModel.Amount =
        this.formDataModel.SalesUMQty *
        this.formDataModel.Price *
        ((100.0 - this.formDataModel.Discount) / 100.0);
      this.formDataModel.Amount =
        this.formDataModel.Amount +
        this.formDataModel.Amount * (this.formDataModel.SalesTaxPcnt / 100.0);
      this.formDataModel.Amount = this.formDataModel.Amount.roundNumber(2);
    },
    async saveAddItemSO() {
      this.saveDisabled = true;
      this.setLoading(true);
      if (this.isValidItem) {
        await ApiService.post("api/Save_SalesOrderDetailSingle", {
          DiscPcnt: this.formDataModel.Discount,
          Comment: this.formDataModel.Comment,
          ItemCode: this.formDataModel.Code,
          // Setting LineNo to 0 means that the API will add the item to the sales order
          LineNo: 0,
          SalesOrderCode: this.salesOrderData.SalesOrderCode,
          SalesUM: this.formDataModel.SalesUM,
          SalesUMPrice: this.formDataModel.Price,
          SalesUMQty: this.formDataModel.SalesUMQty,
        })
          .then(() => {
            this.$notify("Successfully added item.", "Success");
            this.setLoading(false);
            this.callBack(true);
          })
          .catch(() => {
            this.$notify("Failed to Add item.");
            this.setLoading(false);
            this.callBack(false);
          });
      }
      this.setLoading(false);
    },
    async saveAddItemGI() {
      this.saveDisabled = true;
      this.setLoading(true);

      if (this.isValidItem) {
        await ApiService.post("api/Save_PurchaseOrderAddLine", {
          // Setting LineNo to 0 means that the API will add the item to the sales order
          LineNo: "0",
          PurchaseOrderCode: this.addSalesOrderItemData.PurchaseOrderCode,
          BranchCode: this.salesOrderData.BranchCode,
          DivisionCode: this.addSalesOrderItemData.DivisionCode,
          ItemType: this.formDataModel.ItemType,
          ItemCode: this.formDataModel.Code,
          SupplierRequired: this.formDataModel.SalesUMQty,
          FXPrice: this.formDataModel.Price,
          Comment: this.formDataModel.Comment,
          TaxCode: this.formDataModel.TaxCode,
          TaxPcnt: this.formDataModel.SalesTaxPcnt,
          DiscPcnt: this.formDataModel.Discount,
          ETADate: null,
          RequiredByDate: null,
        })
          .then(() => {
            this.$notify("Successfully added item.", "Success");
            this.setLoading(false);
            this.callBack(true);
          })
          .catch(() => {
            this.$notify("Failed to Add item.");
            this.setLoading(false);
            this.callBack(false);
          });
      }
      this.setLoading(false);
    },
    async saveAddItem() {
      if (this.orderType == "so") {
        this.saveAddItemSO();
      } else if (this.orderType == "gi") {
        this.saveAddItemGI();
      }
    },
  },
};
</script>

<style lang="scss">
.edit-product-item-popup-footer {
  padding-top: 10px;
  bottom: 0;
  margin-right: 0px;
  height: 45px;
  text-align: right;

  .save-btn {
    margin-right: 10px;
    background-color: #8bc34a;
  }

  .cancel-btn {
    margin-right: 0px;
    background-color: #ff0033;
  }
}
</style>
